/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Codes_CodeInputs */

const en_tables_contact_codes_code = /** @type {(inputs: Tables_Contact_Codes_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

const de_tables_contact_codes_code = /** @type {(inputs: Tables_Contact_Codes_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

/**
* | output |
* | --- |
* | "Code" |
*
* @param {Tables_Contact_Codes_CodeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_codes_code = /** @type {((inputs?: Tables_Contact_Codes_CodeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Codes_CodeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_codes_code(inputs)
	return de_tables_contact_codes_code(inputs)
});